import { render, staticRenderFns } from "./device-qa.vue?vue&type=template&id=2e216208&scoped=true"
import script from "./device-qa.vue?vue&type=script&lang=js"
export * from "./device-qa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e216208",
  null
  
)

export default component.exports